export class LegacyV31Adapter {
  constructor({ mount }) {
    this.mount = mount;
    this.frame = null;
  }

  launch() {
    if (!this.frame) {
      this.frame = document.createElement('iframe');
      this.frame.className = 'legacy-frame';
      this.frame.title = 'SERPENT v31 compatibility baseline';
      this.frame.allow = 'fullscreen; gamepad; autoplay';
      this.frame.src = '/legacy/v31/index.html';
      this.mount.replaceChildren(this.frame);
      this.frame.addEventListener('load', () => this.focus(), { once: true });
    }
    this.focus();
  }

  focus() {
    this.frame?.focus();
  }
}